import DisplaySticky from "./DisplaySticky";

function DisplayStickyHeader() {
	return <DisplaySticky position="top" />;
}

export default DisplayStickyHeader;